<template>
  <router-view />
</template>

<script>
export default {
  name: "AppealsWrapper",
};
</script>

<style lang="sass"></style>
